<template>
    <div id="app">
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <tanitimMail ref="tanitimdialog" :servisTipi="2"></tanitimMail>
  
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> Transfer Listesi</v-toolbar-title>
            </v-toolbar>
          </v-flex>
         
  
         
        </v-layout>
      </v-card>
      <v-container fluid="">
        <v-layout row wrap="">

<v-flex xs12 sm4 md2>
  <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
    :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"
    v-model="date"></tarihcomp>
</v-flex>

<v-flex xs12 sm4 md2>
  <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
    v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
</v-flex>

<v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="!load1">
                      <v-layout align-center="" fill-height>
                        <v-progress-circular indeterminate color="info"></v-progress-circular>
                      </v-layout>
                    </div>
                   
                  </v-layout>
                </v-flex>
</v-layout>
      </v-container>
      <v-container fluid grid-list-sm>
        <v-data-table
          :rows-per-page-items="[100]"
          :headers="headers"
          :items="items"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">
                <v-icon v-if="props.item.Currency!='' && props.item.Currency!='TRY'">attach_money</v-icon>
              </td>
              <td class="text-xs-left">
                {{ props.item.RecieptDate | dateformat }}
              </td>
              <td class="text-xs-left">
                {{ desingRecieptNumber(props.item.RecieptNumber) }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ReciptType.RecieptTypeName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.Center.CenterName }}
              </td>
              <td class="text-xs-left">
                {{ props.item.TotalDept }}
              </td>
              <td class="text-xs-left">
                {{ props.item.TotalCredit }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ERegistryDocDate | dateformat }}
              </td>
              <td class="text-xs-left">
                {{ props.item.RecieptTitle }}
              </td>
              <td class="text-xs-right">
                <v-btn color="info" @click="git(props.item)" outline fab small>
                  <v-icon>search</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{
          $t("Close")
        }}</v-btn>
      </v-snackbar>
      
  
     
    </div>
  </template>
  
  <script>
  import auth from "@/api/auth.js";
  import _ from "underscore";
  import router from "@/router.js";
  import helpers from "@/components/app/customcomp/helpers.js";
  import tarihim from "@/components/app/customcomp/tarihim.vue";
  import parainputevents from "@/components/app/customcomp/parainputevents";
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput";
  import hotelloadingcomp from "@/components/app/customcomp/hotelloadingcomp.vue";
  import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tarihcomp from "@/components/app/customcomp/tarihim"
  //import VueGoogleMaps from "vue2-google-maps"
  
  export default {
    data() {
      return {
         firmaBilgileri:null,
       bookingUserName:'',
       bookingUserPassword:'',
        headers:[
        {
          text:"PNR",
          
        },
        {
          text:"Statü",
          
        },
        {
          text:"Tedarikçi",
          
        },
        {
          text:"Ad",
          
        },
        {
          text:"Soyad",
          
        },
        {
          text:"Nereden",
          
        },
        {
          text:"Nereye",
          
        },
        {
          text:"Ana Fiyat",
          
        },
        {
          text:"Vergiler",
          
        },
        {
          text:"Markup",
          
        },
        {
          text:"Toplam",
          
        },
        ],
        load1:true,
        date:null,
        date2:null,
        rules: {
          required: (value) => !!value || this.$t("Mandatory-Areas"),
        },
        yetkidialog: false,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        SessionId:'',
        SessionToken:'',
        pagenumber: 1,
        sayfalama: 1,
        paginationDisabled: false,
        vmodelpagination: false,
        islemTipi: null,
        loadingdialog: false,
        validform: true,
        progress: true,
        Time: "",
        search: "",
        search2: "",
        Azalt: false,
       
        menu: false,
        yetiskinSayi: 1,
        cocukSayi: 0,
        bebekSayi: 0,
        items:[],
        transferaditems: [],
        transferbirakaditems: [],
        alinisitems: [],
        birakilisitems: [],
        transferitems: [],
        markupitems: [
          {
            text: this.$t("Percentage"),
            value: "PT",
          },
          {
            text: this.$t("Amount"),
            value: "PC-1",
          },
        ],
      
        LocationInput: {
          Text: null,
          Id: 0,
        },
        siralamatipiitems: [
          {
            text: this.$t("Price-Ascending"),
            value: "Price",
          },
          {
            text: this.$t("Price-Descending"),
            value: "PriceDesc",
          },
        ],
        kuritems: [
          {
            text: "TRY",
            vakye: "TRY",
          },
          {
            text: "EUR",
            value: "EUR",
          },
          {
            text: "USD",
            value: "USD",
          },
          {
            text: "GBP",
            value: "GBP",
          },
        ],
        aramaYapildimi: false,
        aramaYapildimiBirak: false,
        kayitvarmi: false,
        kayitsayi: 0,
        clipped: true,
        drawer: true,
        fixed: false,
        right: true,
        dialog: false,
        loginstatus: true,
        drawer: null,
        text1: "",
        snackbar: false,
        loading: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        confirm: null,
        Credential: {
          email: "",
          password: "",
        },
        valid: true,
      };
    },
    props: {
      source: String,
    },
     mounted() {
     
      this.BookingKontrol();
     
    },
    methods: {
     async BookingKontrol() {
this.loadingdialog = true;
  const coperFirmaBilgileri = await this.FirmaBilgileriGetir();
  if (!coperFirmaBilgileri) {
    return;
  }

  const ekUrunVar = await this.EkurunGetir();
  if (!ekUrunVar) {
    return;
  }

  
  const firmaVar = await this.chkAgency();
  if (!firmaVar) {
   const firmaEklendi = await this.addAgency2();
  if (!firmaEklendi) {
    return;
  }
  }
  

  if (firmaVar || firmaEklendi)
  {
    await this.login();
  }
  this.loadingdialog = false;
  
},
    async addAgency2()
    {
      this.loadingdialog = true;
 var credentials = JSON.parse(window.localStorage.getItem("credentials"));

var params={
  Name:credentials.CoperSirketAdi,
  City:this.firmaBilgileri.City,
  District:this.firmaBilgileri.District,
  CountryCode:"TR",
  Address:this.firmaBilgileri.Address,
  Gsm:this.firmaBilgileri.Gsm,
  Email:this.firmaBilgileri.Email,
  TaxOffice:this.firmaBilgileri.TaxOffice,
  TaxNo:this.firmaBilgileri.TaxNo};

  this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddAgency", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
         (response) => {
          console.log(response);
         if (response.body.Usernanme!=null)
         {
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
         }
            console.log(response);
            this.loadingdialog = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
              return false;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
              return false;
            }
          }
        );
       this.loadingdialog = false;
        return true;
       
    },
async FirmaBilgileriGetir() {
  this.loadingdialog =true;
  try {
    const credentials = JSON.parse(window.localStorage.getItem("credentials"));
    const paramscompany = {
      SirketKodu: credentials.SirketKodu
    };
    const responsecompany = await this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', paramscompany, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    this.firmaBilgileri = {
      Name: credentials.CoperSirketAdi,
      City: responsecompany.body.Il,
      District: responsecompany.body.Ilce,
      CountryCode: "TR",
      Address: responsecompany.body.Adres,
      Gsm: responsecompany.body.Tel,
      Email: responsecompany.body.Email,
      TaxOffice: responsecompany.body.VergiDairesi,
      TaxNo: responsecompany.body.VergiNo
    };
console.log(this.firmaBilgileri);
    if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
      this.text1 = "Firma Mail Adresi veya Vergi Numarası Bulunamadı";
      this.loadingdialog = false;
      this.snackbar = true;
      return false;
    }
    this.loadingdialog = false;
    return true;
  } catch (error) {
    this.text1 = "Service Unavailable";
    this.loadingdialog = false;
    this.snackbar = true;
    return false;
  }
},

async EkurunGetir() {
  this.loadingdialog = true;
  try {
    const params3 = {
      GrupID: null,
      UrunID: null,
      MusteriID: null
    };

    const response = await this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    const ekurun = response.body[3].Aktif;

    if (!ekurun) {
      this.text1 = "Pazar Yeri Ürünü Bulunamadı";
      this.loadingdialog = false;
      this.snackbar = true;
      return false;
    }
this.loadingdialog = false;
    return true;
  } catch (error) {
    this.text1 = "Service Unavailable";
    this.loadingdialog = false;
    this.snackbar = true;
    return false;
  }
},

async chkAgency() {
  this.loadingdialog = true;
  try {
    const params = {
      Email: this.firmaBilgileri.Email,
      TaxNo: this.firmaBilgileri.TaxNo,
    };
    const response = await this.$http.post(auth.BOOKING_API_URL + 'Agency/CheckAgency', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });
   
    if (response.body.HasError)
    {
      this.loadingdialog = false;
       return false;
    }
    else
    {
      this.loadingdialog = false;
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
          return true;
    }
  } catch (error) {
    this.loadingdialog = false;
    console.log(error);
    return false;
  }
},
     async login()
    {
      
      this.loadingdialog = true;
      var params = {
        Username: this.bookingUserName,
  Password: this.bookingUserPassword,
  IsTest: true

      };

      this.$http
        .post( auth.BOOKING_API_URL + "Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
         
           this.SessionId=response.body.SessionId;
           this.SessionToken=response.body.SessionToken;
           window.localStorage.setItem(
              "transferBookingParams",
              JSON.stringify(response.body)
            );
            this.loadingdialog = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.loadingdialog = false;
              this.snackbar = true;
            }
          }
        );
    },
      getImgUrl(pet) {
      return "https://partner.paxdrive.com" + pet;
      
    },
     
      getparabirimi() {
        return ""; // helpers.getparabirimi()
      },
    
     getList()
     {
      var bookingParams = JSON.parse(
          window.localStorage.getItem("transferBookingParams")
        );
        var params={
        SessionHeader:{
      SessionId: bookingParams.SessionId,
      SessionToken:bookingParams.SessionToken
    },
    InsertStartDate :this.date,
    InsertEndDate : this.date2,
    Status:"Booked",
    ProviderType :"Transfer",
    TopTake: false
        }

        this.$http
    .post(auth.BOOKING_API_URL + "Report/Reservations", params, {
      
    })
    
     
     
     
    },
    
    
   
  },
   filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      timeformat: function (c) {
        return helpers.timeformat(c);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
    },
  components: {
      tarihim,
      parainputevents,
      yuzdeinput,
      hotelloadingcomp,
      tanitimMail,
      yetkidialog,
      tarihcomp
    },
};
  
  
  </script>
  
  <style scoped>
  .responsive {
    max-width: 100%;
    height: auto;
  }
  </style>